import styled from 'styled-components';

export const AccountContainer = styled.div`
  background-color: ${(props) => props.theme.color.bg.muted};
  width: 100%;
  padding-top: 64px;
  min-height: calc(100vh - 60px);
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1416px;
  margin-left: auto;
  margin-right: auto;
  background: ${(props) => props.theme.color.bg.primary};

  @media only screen and (max-width: 768px) {
    /* Stack sidebar above content */
    > .d-flex {
      flex-direction: column;

      /* Override Bootstrap heavy spacing on the main content panel */
      > div + div {
        padding-left: 20px !important;
        padding-right: 20px !important;
        padding-top: 20px !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
        margin-top: 0 !important;
      }
    }
  }
`;

export const LeftContainer = styled.div`
  width: 240px;
  min-height: 70vh;
  flex-shrink: 0;
  background-color: ${(props) => props.theme.color.bg.tertiary};

  @media only screen and (max-width: 768px) {
    width: 100%;
    min-height: auto;
  }
`;

export const Title = styled.h1`
  font-family: Poppins;
  font-size: 16px;
  color: ${(props) => props.theme.color.text.inverse};
  line-height: normal;
`;

export const Subtitle = styled.p`
  color: ${(props) => props.theme.color.text.inverse};
  font-family: Montserrat;
  font-size: 14px;
  line-height: normal;
`;

export const Links = styled.nav`
  button {
    color: ${(props) => props.theme.color.text.inverse};
    height: 50px;
    text-align: left;
    padding-left: 16px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 700;
    line-height: normal;
    border-radius: 0;
    &.btn-light {
      color: ${(props) => props.theme.color.text.tertiary};
      svg {
        &:first-of-type {
          display: none;
        }
        &:nth-of-type(2) {
          display: inline-block;
        }
      }
    }
    &:hover {
      background: ${(props) => props.theme.color.bg.primary};
      color: ${(props) => props.theme.color.text.tertiary};
      svg {
        &:first-of-type {
          display: none;
        }
        &:nth-of-type(2) {
          display: inline-block;
        }
      }
    }
    svg {
      display: none;
      &:first-of-type {
        display: inline-block;
      }
    }
  }
`;

export const SectionTitle = styled.h2`
  font-family: Poppins;
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => props.theme.color.text.tertiary};
  margin-bottom: 4px;
`;

export const SectionSubtitle = styled.p`
  font-family: Montserrat;
  font-size: 14px;
  color: ${(props) => props.theme.color.text.quaternary};
  margin-bottom: 0;
`;

/* ─── Current plan banner ─── */

export const CurrentPlanBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${(props) => props.theme.color.bg.tertiary};
  border-radius: 3px;
  padding: 24px 32px;
  gap: 24px;

  @media only screen and (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
  }
`;

export const PlanBadge = styled.span<{ planName: string }>`
  display: inline-block;
  padding: 4px 16px;
  border-radius: 3px;
  font-family: Montserrat;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.5px;
  background-color: ${({ planName }) => {
    if (planName === 'Free') return '#e6e6e6';
    if (planName === 'Starter') return '#f9d815';
    if (planName === 'Business') return '#f79422';
    if (planName === 'Enterprise') return '#98c52f';
    return '#e6e6e6';
  }};
  color: ${({ planName }) => {
    if (planName === 'Free') return '#333333';
    if (planName === 'Starter') return '#333333';
    return '#ffffff';
  }};
`;

export const PlanPriceTag = styled.div`
  font-family: Poppins;
  font-size: 28px;
  font-weight: 700;
  color: ${(props) => props.theme.color.text.inverse};
  span {
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.color.text.inverse};
    opacity: 0.75;
  }
`;

export const PlanBannerInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  h3 {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.75);
    margin: 0;
  }
`;

export const UpgradeBannerButton = styled.button`
  padding: 10px 24px;
  background: ${(props) => props.theme.color.ui.orange};
  color: white;
  border: none;
  border-radius: 3px;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    filter: brightness(0.93);
  }
`;

/* ─── UC Usage ─── */

export const UsageCard = styled.div`
  border: 1px solid ${(props) => props.theme.color.ui.shade2};
  border-radius: 3px;
  padding: 24px 28px;
`;

export const UsageRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const UsageLabel = styled.span`
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.color.text.primary};
`;

export const UsageCount = styled.span`
  font-family: Poppins;
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => props.theme.color.text.tertiary};
`;

export const ProgressBarOuter = styled.div`
  width: 100%;
  height: 10px;
  background: ${(props) => props.theme.color.ui.shade2};
  border-radius: 3px;
  overflow: hidden;
`;

export const ProgressBarInner = styled.div<{ pct: number; overLimit: boolean }>`
  height: 100%;
  width: ${({ pct }) => Math.min(pct * 100, 100)}%;
  background: ${({ overLimit, theme }) =>
    overLimit ? theme.color.ui.orange : theme.color.ui.greenAlt};
  border-radius: 3px;
  transition: width 0.4s ease;
`;

export const UsageNote = styled.p`
  font-family: Montserrat;
  font-size: 12px;
  color: ${(props) => props.theme.color.text.quaternary};
  margin-top: 8px;
  margin-bottom: 0;
`;

export const AdditionalUcBox = styled.div`
  margin-top: 16px;
  padding: 14px 20px;
  background: ${(props) => props.theme.color.bg.warning};
  border: 1px solid ${(props) => props.theme.color.ui.yellow};
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  p {
    font-family: Montserrat;
    font-size: 13px;
    color: ${(props) => props.theme.color.text.primary};
    margin: 0;
    b {
      font-weight: 700;
    }
  }
`;

export const ContactButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  background: ${(props) => props.theme.color.ui.orange};
  color: white;
  border: none;
  border-radius: 3px;
  font-family: Montserrat;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  &:hover {
    filter: brightness(0.93);
    color: white;
  }
`;

/* ─── Plan cards ─── */

export const PlansGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media only screen and (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 580px) {
    grid-template-columns: 1fr;
  }
`;

export const PlanCard = styled.div<{
  isCurrent: boolean;
  recommended: boolean;
}>`
  border-radius: 3px;
  border: 2px solid
    ${({ isCurrent, recommended, theme }) => {
      if (isCurrent) return theme.color.ui.orange;
      if (recommended) return theme.color.ui.tertiary;
      return theme.color.ui.shade2;
    }};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const PlanCardHeader = styled.div<{
  isCurrent: boolean;
  recommended: boolean;
}>`
  padding: 20px 20px 16px;
  background: ${({ isCurrent, recommended, theme }) => {
    if (isCurrent) return theme.color.ui.orange;
    if (recommended) return theme.color.bg.tertiary;
    return theme.color.bg.muted;
  }};

  h3 {
    font-family: Poppins;
    font-size: 18px;
    font-weight: 700;
    color: ${({ isCurrent, recommended }) =>
      isCurrent || recommended ? '#ffffff' : '#333333'};
    margin: 0 0 2px;
  }

  p {
    font-family: Montserrat;
    font-size: 12px;
    color: ${({ isCurrent, recommended }) =>
      isCurrent || recommended ? 'rgba(255,255,255,0.8)' : '#999999'};
    margin: 0;
  }
`;

export const PlanCardPrice = styled.div`
  padding: 16px 20px 12px;
  border-bottom: 1px solid ${(props) => props.theme.color.ui.shade2};

  .price-value {
    font-family: Poppins;
    font-size: 26px;
    font-weight: 700;
    color: ${(props) => props.theme.color.text.tertiary};
  }

  .price-period {
    font-family: Montserrat;
    font-size: 12px;
    color: ${(props) => props.theme.color.text.quaternary};
  }

  .price-free {
    font-family: Poppins;
    font-size: 22px;
    font-weight: 700;
    color: ${(props) => props.theme.color.ui.greenAlt};
  }
`;

export const PlanCardFeatures = styled.ul`
  list-style: none;
  padding: 16px 20px;
  margin: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;

  li {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-family: Montserrat;
    font-size: 13px;
    color: ${(props) => props.theme.color.text.primary};
    line-height: 1.4;

    svg {
      flex-shrink: 0;
      margin-top: 2px;
    }
  }
`;

export const PlanCardFooter = styled.div`
  padding: 0 20px 20px;
`;

export const PlanCardButton = styled.button<{
  isCurrent: boolean;
  disabled?: boolean;
}>`
  width: 100%;
  padding: 10px;
  border-radius: 3px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: Montserrat;
  font-size: 13px;
  font-weight: 700;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  background: ${({ isCurrent, theme }) =>
    isCurrent ? theme.color.ui.shade2 : theme.color.ui.orange};
  color: ${({ isCurrent, theme }) =>
    isCurrent ? theme.color.text.quaternary : theme.color.text.inverse};

  &:hover {
    filter: ${({ disabled }) => (disabled ? 'none' : 'brightness(0.93)')};
  }
`;

export const RecommendedTag = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background: ${(props) => props.theme.color.ui.yellow};
  color: #333;
  font-family: Montserrat;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 3px;
  letter-spacing: 0.5px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${(props) => props.theme.color.ui.shade2};
`;

/* ─── Next invoice estimate ─── */

export const InvoiceEstimateCard = styled.div`
  border: 2px solid ${(props) => props.theme.color.ui.orange};
  border-radius: 3px;
  overflow: hidden;
`;

export const InvoiceEstimateHeader = styled.div`
  background: ${(props) => props.theme.color.ui.orange};
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 10px;

  h4 {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 700;
    color: white;
    margin: 0;
  }

  svg {
    color: white;
    flex-shrink: 0;
  }
`;

export const InvoiceEstimateBody = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InvoiceEstimateLine = styled.div<{ bold?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Montserrat;
  font-size: ${({ bold }) => (bold ? '15px' : '13px')};
  font-weight: ${({ bold }) => (bold ? '700' : '400')};
  color: ${({ bold, theme }) =>
    bold ? theme.color.text.tertiary : theme.color.text.primary};

  span:last-child {
    font-weight: 700;
  }
`;

export const InvoiceEstimateDivider = styled.div`
  height: 1px;
  background: ${(props) => props.theme.color.ui.shade2};
  margin: 4px 0;
`;

export const InvoiceEstimateTotal = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 4px;

  span:first-child {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    color: ${(props) => props.theme.color.text.primary};
  }

  .total-value {
    font-family: Poppins;
    font-size: 24px;
    font-weight: 700;
    color: ${(props) => props.theme.color.ui.orange};
  }

  .total-period {
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 400;
    color: ${(props) => props.theme.color.text.quaternary};
  }
`;

export const SuccessBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: ${(props) => props.theme.color.bg.success};
  border: 1px solid ${(props) => props.theme.color.ui.greenAlt};
  border-radius: 3px;
  font-family: Montserrat;
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => props.theme.color.ui.greenAlt};

  svg {
    flex-shrink: 0;
  }
`;

export const AvatarImage = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  margin: 24px auto 0;
`;
